import { TagTypeDto } from '@buck-e-icp/interfaces';

export const filterTagTypeCategory = (tagTypes: TagTypeDto[], categoryName: string): TagTypeDto[] =>
    tagTypes
        .filter((tagType) => {
            const category = tagType.metaData.find((meta) => meta.key === 'category');

            return category !== undefined && category.value === categoryName;
        })
        .sort((a, b) => {
            const categoryA = a.metaData.find((meta) => meta.key === 'order')!;
            const categoryB = b.metaData.find((meta) => meta.key === 'order')!;

            return Number(categoryA.value) - Number(categoryB.value);
        });
